//import React from 'react'
//import Nav from './navbar-hp';
//import { Outlet, Link, NavLink } from "react-router-dom";
import { useState, useEffect } from "react"
import "98.css";

import ITookATrip from './lyrics/itookatrip';
import Midnight from './lyrics/midnight';
import DiscoonNeptune from './lyrics/discoonneptune';
import TheGoodTheBad from './lyrics/thegoodthebad';
import OEOTD from './lyrics/oneeyeonthedoor';

export default function Notepad({fileName, songName, onClose}) {

    useEffect(() => {
        clearActiveWindow();
        document.querySelector('.window-container').append(document.querySelector('.window[data-name="Notepad"]'));
        
        return () => {
            //console.log('Component will unmount');
        };
    }, []);

    function clearActiveWindow() {
        document.querySelectorAll('.window').forEach(window => {
            window.classList.remove('active');
        })
    }

    function minimise(e) {
        var selector = e.target;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');
        //dataName = '[data-name="' + dataName + '"]';

        tray.querySelector('[data-name="' + dataName + '"]').removeAttribute('aria-selected');
        selector.closest('.window') && selector.closest('.window').classList.add('hidden');
    }

    // function reOpen(selector) {
        
    //     document.querySelectorAll('.tray button').forEach(item => {
    //         item.removeAttribute('aria-selected');
    //     });

    //     var selector = selector.target;
    //     //console.log(selector);
    //     var dataName = selector.getAttribute('data-name');

    //     document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));

    //     if (document.querySelector('.window[data-name="' + dataName + '"]')) {
    //         selector.ariaSelected = 'true';
    //         document.querySelector('.window[data-name="' + dataName + '"]').classList.remove('hidden');
    //     }
    // }
   
    function reOpen(selector) {
    
        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });

        var selector = selector.target;
        var dataName = selector.getAttribute('data-name');
        console.log(selector)
        //console.log(selector.nodeName)

        //if (selector.nodeName !== 'BUTTON' && (selector.classList.contains('toolbar-button') || selector.parentElement.classList.contains('toolbar-button'))) return;
        if (selector.nodeName === 'BUTTON' && (selector.classList.contains('form-minimise') || selector.classList.contains('form-close'))) return;
        
        //Toolbar tab buttons
        if (selector.nodeName === 'BUTTON' && selector.classList.contains('toolbar-tab')) {
            dataName = selector.getAttribute('data-name');
            if (document.querySelector('.window[data-name="' + dataName + '"]')) {
                selector.ariaSelected = 'true';
                document.querySelector('.window[data-name="' + dataName + '"]').classList.remove('hidden');
                document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
            }
        } else {
            selector = selector.closest('.window');
            dataName = selector.getAttribute('data-name');
        }

        
        if (!document.querySelector('.window[data-name="' + dataName +'"]').classList.contains('active')) {
            clearActiveWindow();
            document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
        }

    }
    
    // function hideContactForm(e) {
    //     var el = e.target;
    //     //console.log(el);
    //     var dataName = el.getAttribute('data-name');
    //     checkTray(el, true);
    //     document.querySelector('.window[data-name="' + dataName + '"]').classList.add('hidden');
    // }

    function checkTray(selector, close=false) {
        var selector = selector;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');

        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });
        //dataName = '[data-name="' + dataName + '"]';
    
        //console.log(dataName)
        if (!tray.querySelector('[data-name="' + dataName + '"]')) {
            //console.log('not in tray, add it!')

            document.querySelectorAll('.tray button').forEach(item => {
                item.ariaSelected = 'false';
            });
    
            var el = document.createElement('button');
            el.role = "tab";
            el.innerText = dataName;
            //el.insertAdjacentHTML('afterbegin', '<a>' + dataName + '</a>');
            el.ariaSelected = "true";
            el.setAttribute('data-name', dataName);
            el.onclick = reOpen;
            document.querySelector('.tray menu').insertAdjacentElement('beforeend', el);

            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else if (!close) {
            
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else {
            //console.log('already in tray');
            tray.querySelector('[data-name="' + dataName + '"]').remove();
        }
    }

    let song;
    if (songName === 'ITAT') {
        song = <ITookATrip />;
    } else if (songName === 'Midnight') {
        song = <Midnight />;
    } else if (songName === 'DON') {
        song = <DiscoonNeptune />;
    } else if (songName === 'TGBH') {
        song = <TheGoodTheBad />;
    } else if (songName === 'OEOTD') {
        song = <OEOTD />;
    }

    return (
        <>

        <div className="window active" data-name="Notepad" onClick={reOpen}>

            <div className="title-bar">
                <div className="title-bar-text">{fileName}.txt</div>
                <div className="title-bar-controls">
                    <button className="form-minimise" aria-label="Minimize" onClick={minimise} data-name="Notepad"></button>
                    <button className="form-close" aria-label="Close" onClick={onClose} data-name="Notepad"></button>
                </div>
            </div>

            <div className="window-body">{song}</div>

        </div>

        </> 
    )
}